module.exports = __webpack_public_path__ + "img/emoji_35.c83bbf01.png";